import { render } from "./TaskSettingsRenderer.vue?vue&type=template&id=8dd6eab4"
import script from "./TaskSettingsRenderer.vue?vue&type=script&lang=js"
export * from "./TaskSettingsRenderer.vue?vue&type=script&lang=js"

import "./TaskSettingsRenderer.vue?vue&type=style&index=0&id=8dd6eab4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__